import type { IconProps } from './types';
import './icons.css';

export default function Clock({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 18}
      height={height || 18}
      viewBox="0 0 18 18"
      className={`icon icon-clock ${className || ''}`}
    >
      <path
        d="M9 15.938A6.938 6.938 0 1 0 9 2.063a6.938 6.938 0 0 0 0 13.875Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        fill="transparent"
      />
      <path
        d="M8.438 5.063v4.125l1.874 1.874"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
